// -----------------------------------------------------------------------------
// NOTIFICATIONS BADGE (round 31 #5, Kyle 01/Nov/26) — the number on the K avatar and on "Notifications" in the profile
// menu: requests waiting for my Approve / Reject + decisions on my requests I have not opened yet (notifications_count,
// 0022). Bell only for now — no emails. Read when the app starts, every 2 minutes, and right after anything that can
// change it (refreshBadge(): Propose change, Approve / Reject, opening the Notifications page).
// -----------------------------------------------------------------------------
import { useEffect, useState } from "react";
import { rpc } from "./api/backend";

const EVENT = "buildnexx:badge";
let last = 0;

/** Ask every badge on screen to read the count again. */
export function refreshBadge(): void { window.dispatchEvent(new Event(EVENT)); }

/** The current badge number (0 = no badge). */
export function useBadge(): number {
  const [n, setN] = useState(last);
  useEffect(() => {
    let alive = true;
    const read = () => rpc("notifications_count").then((r) => { last = r.badge; if (alive) setN(r.badge); }).catch(() => {});
    read();
    const t = window.setInterval(read, 120_000);
    window.addEventListener(EVENT, read);
    return () => { alive = false; window.clearInterval(t); window.removeEventListener(EVENT, read); };
  }, []);
  return n;
}
